export { default } from '../modules/cache'